// extracted by mini-css-extract-plugin
module.exports = {"benefits":"styles_benefits__JVWCR","pulse":"styles_pulse__JCIyq","jump":"styles_jump__0hm_s","wiggle":"styles_wiggle__wc_iO"};